import { FulfilmentCentre } from '../../redux-toolkits/fulfilment-centres/fulfilmentCentres.type'
import { VariantCombination } from '../../redux-toolkits/products/products.type'
import { TextInput } from '../inputs/textInput'
import { TableComponent } from '../table'
import { HeaderSubheader } from '../typography/HeaderSubheader'
import {
  getVariantCombinationInventoryKey,
  ProductInventoryQuantities,
  sumInventoryQuantities,
  sumVariantInventoryQuantities,
  VariantInventoryQuantities,
} from './productInventory'

export const ManageProductInventory = ({
  fulfilmentCentres,
  isVariant,
  productQuantities,
  variantCombinations,
  variantQuantities,
  onProductQuantityChange,
  onVariantQuantityChange,
}: {
  fulfilmentCentres: FulfilmentCentre[]
  isVariant: boolean
  productQuantities: ProductInventoryQuantities
  variantCombinations: VariantCombination[]
  variantQuantities: VariantInventoryQuantities
  onProductQuantityChange: (
    fulfilmentCentreId: string,
    quantity: number,
  ) => void
  onVariantQuantityChange: (
    variantCombinationKey: string,
    fulfilmentCentreId: string,
    quantity: number,
  ) => void
}) => {
  const totalQuantity = isVariant
    ? sumVariantInventoryQuantities(variantQuantities, variantCombinations)
    : sumInventoryQuantities(productQuantities)

  return (
    <div className="flex flex-col gap-6 pb-10 border-b border-divider-gray">
      <HeaderSubheader
        title="Inventory by fulfilment centre"
        text="Stock entered here is available only from its assigned fulfilment centre."
      />

      <p className="text-sm text-sec-black">
        Stock at your assigned centres:{' '}
        <span className="font-medium">{totalQuantity}</span>
      </p>

      {isVariant ? (
        <TableComponent
          headers={[
            'Variation',
            ...fulfilmentCentres.map(({ name }) => name),
            'Total',
          ]}
          rows={variantCombinations.map((combination) => {
            const combinationKey =
              getVariantCombinationInventoryKey(combination)
            const quantities = variantQuantities[combinationKey] ?? {}

            return {
              id: combinationKey,
              content: [
                combination.variantCombination
                  .map(({ value }) => value)
                  .join(', '),
                ...fulfilmentCentres.map((centre) => (
                  <TextInput
                    key={`${combinationKey}-${centre._id}`}
                    type="number"
                    min={0}
                    step={1}
                    value={String(quantities[centre._id] ?? 0)}
                    onChange={(event) => {
                      onVariantQuantityChange(
                        combinationKey,
                        centre._id,
                        Math.max(0, Number(event.target.value)),
                      )
                    }}
                    hasIcon={false}
                    className="!p-2 min-w-[110px]"
                  />
                )),
                sumInventoryQuantities(quantities),
              ],
            }
          })}
          isEmpty={variantCombinations.length === 0}
          emptyText="Add variant combinations before assigning inventory."
        />
      ) : (
        <TableComponent
          headers={['Fulfilment centre', 'Quantity']}
          rows={fulfilmentCentres.map((centre) => ({
            id: centre._id,
            content: [
              centre.name,
              <TextInput
                key={centre._id}
                type="number"
                min={0}
                step={1}
                value={String(productQuantities[centre._id] ?? 0)}
                onChange={(event) => {
                  onProductQuantityChange(
                    centre._id,
                    Math.max(0, Number(event.target.value)),
                  )
                }}
                hasIcon={false}
                className="!p-2 max-w-[180px]"
              />,
            ],
          }))}
          isEmpty={fulfilmentCentres.length === 0}
          emptyText="You are not assigned to any of this creator’s fulfilment centres."
        />
      )}
    </div>
  )
}
